import { render } from "./CoinInfoMobile.vue?vue&type=template&id=cc96c3de"
import script from "./CoinInfoMobile.vue?vue&type=script&lang=js"
export * from "./CoinInfoMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__